module.exports = __webpack_public_path__ + "static/media/tree-step-4_4.f962848f.svg";